import { localSetItem, localGetItem } from '@/utils';

const allMenus = [];

class OpenMenus {
  menus = [];

  setOpenMenus(nextRoute) {
    const current = this.menus.find(menu => menu.name === nextRoute.name);
    if (!current) {
      const menuItem = {
        fullPath: nextRoute.fullPath,
        name: nextRoute.name,
        pageTitle: nextRoute.meta.pageTitle,
        auth: nextRoute.meta.auth,
      };
      this.menus = this.menus.concat([menuItem]);
    } else {
      current.fullPath = nextRoute.fullPath;
    }
    localSetItem('openMenus', JSON.stringify(this.menus));
  }

  removeOpenMenus(closeMenus) {
    this.menus = this.menus.filter(menu => closeMenus.indexOf(menu) === -1);
    localSetItem('openMenus', JSON.stringify(this.menus));
  }
}

export const openMenus = new OpenMenus();

export const initMenus = pageRoutes => {
  allMenus.splice(0);
  pageRoutes.forEach(moduleMenu => {
    if (moduleMenu.children.length) {
      moduleMenu.children.forEach(menu => {
        allMenus.push(menu);
      });
    }
  });
  try {
    const cacheMenus = localGetItem('openMenus') || [];
    openMenus.menus = cacheMenus.filter(cm => allMenus.find(menu => menu.name === cm.name));
  } catch {
    console.log('openMenus cache parse error');
    localSetItem('openMenus', '[]');
    openMenus.menus = [];
  }
  localSetItem('openMenus', JSON.stringify(openMenus.menus));
};
